var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgToolSegThreshold = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0z"
}), /*#__PURE__*/React.createElement("g", {
  stroke: "currentColor",
  strokeWidth: 1.5,
  transform: "translate(2.418 14.367)"
}, /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "round",
  d: "M16.582 2.133h2.5M.082 2.133h12"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 14.224,
  cy: 2.092,
  r: 2.092
})), /*#__PURE__*/React.createElement("g", {
  stroke: "currentColor",
  strokeWidth: 1.5,
  transform: "matrix(-1 0 0 1 21.5 5.367)"
}, /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "round",
  d: "M16 2.133h3.082M.082 2.133H11"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 13.224,
  cy: 2.092,
  r: 2.092
})))));
export { SvgToolSegThreshold as ReactComponent };
export default __webpack_public_path__ + "assets/images/tool-seg-threshold.svg";